import { isPromoCodeActive } from '@eventbrite/consumer-search.event-renderer';
import type { FormattedEvent } from '@eventbrite/consumer-search.event-renderer';

/**
 * Mirrors discover-utils `getEventCardSignalsVisibility` (not exported from package root).
 */
export function getEventCardSignalsVisibility({
  event,
  withLimitedVisibility,
}: {
  event: FormattedEvent;
  withLimitedVisibility: boolean;
}): {
  showUrgencySignals: boolean;
  showDiscountCode: boolean;
  showBOGOLabel: boolean;
} {
  if (!withLimitedVisibility) {
    return {
      showUrgencySignals: true,
      showDiscountCode: true,
      showBOGOLabel: true,
    };
  }
  if (event.specialDiscounts?.hasBogoTickets) {
    return {
      showUrgencySignals: false,
      showDiscountCode: false,
      showBOGOLabel: true,
    };
  }
  if (isPromoCodeActive(event.openDiscount)) {
    return {
      showUrgencySignals: false,
      showDiscountCode: true,
      showBOGOLabel: false,
    };
  }
  return {
    showUrgencySignals: true,
    showDiscountCode: false,
    showBOGOLabel: false,
  };
}
